import { CreditCard, Receipt, Download, Calendar } from 'lucide-react';

interface BillingSettingsProps {
  isGlobalDarkMode: boolean;
}

export const BillingSettings: React.FC<BillingSettingsProps> = ({ isGlobalDarkMode: _ }) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Current Plan Card */}
        <div className="rounded-lg border p-6 bg-card border-border">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-2 rounded-lg bg-workspace-accent/15 text-workspace-accent">
              <CreditCard className="w-5 h-5" />
            </div>
            <h3 className="text-lg font-semibold text-foreground">Current Plan</h3>
          </div>

          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <h4 className="text-xl font-bold text-foreground">Pro Plan</h4>
                <p className="text-sm text-muted-foreground">$29/month</p>
              </div>
              <span className="px-3 py-1 text-sm font-medium rounded-full bg-success/15 text-success">
                Active
              </span>
            </div>
            <button className="px-4 py-2 bg-workspace-accent hover:bg-workspace-accent-hover text-white rounded-lg font-medium transition-colors">
              Change Plan
            </button>
          </div>
        </div>

        {/* Payment Method Card */}
        <div className="rounded-lg border p-6 bg-card border-border">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-2 rounded-lg bg-info/15 text-info">
              <CreditCard className="w-5 h-5" />
            </div>
            <h3 className="text-lg font-semibold text-foreground">Payment Method</h3>
          </div>

          <div className="space-y-4">
            <div className="flex items-center justify-between p-3 rounded-lg bg-muted">
              <div className="flex items-center gap-3">
                <div className="w-10 h-6 rounded bg-muted-foreground/20"></div>
                <div>
                  <p className="font-medium text-foreground">•••• •••• •••• 4242</p>
                  <p className="text-sm text-muted-foreground">Expires 12/25</p>
                </div>
              </div>
              <span className="px-2 py-1 text-xs font-medium rounded bg-workspace-accent/15 text-workspace-accent">
                Default
              </span>
            </div>
            <button className="px-4 py-2 bg-workspace-accent hover:bg-workspace-accent-hover text-white rounded-lg font-medium transition-colors">
              Add Payment Method
            </button>
          </div>
        </div>
      </div>

      {/* Billing History Card */}
      <div className="rounded-lg border p-6 bg-card border-border">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 rounded-lg bg-success/15 text-success">
            <Receipt className="w-5 h-5" />
          </div>
          <h3 className="text-lg font-semibold text-foreground">Billing History</h3>
        </div>

        <div className="space-y-3">
          <div className="flex items-center justify-between p-3 rounded-lg bg-muted">
            <div className="flex items-center gap-3">
              <Calendar className="w-4 h-4 text-muted-foreground" />
              <div>
                <p className="font-medium text-foreground">Pro Plan - Monthly</p>
                <p className="text-sm text-muted-foreground">March 1, 2024</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <span className="font-medium text-foreground">$29.00</span>
              <button className="p-1 transition-colors text-muted-foreground hover:text-foreground">
                <Download className="w-4 h-4" />
              </button>
            </div>
          </div>

          <div className="flex items-center justify-between p-3 rounded-lg bg-muted">
            <div className="flex items-center gap-3">
              <Calendar className="w-4 h-4 text-muted-foreground" />
              <div>
                <p className="font-medium text-foreground">Pro Plan - Monthly</p>
                <p className="text-sm text-muted-foreground">February 1, 2024</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <span className="font-medium text-foreground">$29.00</span>
              <button className="p-1 transition-colors text-muted-foreground hover:text-foreground">
                <Download className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
